export default __webpack_public_path__ + "static/media/BAN1.bd70f51f.jpg";